import React from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../SEO/PageMeta';
import DailyMockTest from './DailyMockTest';
import './LandingPage.css';

const title = 'Free UPSC Prelims Daily Mock Test & Question Paper | CivilFox';
const description = 'Practice UPSC Civil Services Prelims with CivilFox’s free daily mock test question paper and answer sheet. Download today’s paper and check your answers.';

export default function MockTestPage() {
  return (
    <div className="cf cf-feature-page">
      <PageMeta
        title={title}
        description={description}
        path="/mock-test"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: title,
          description,
          url: 'https://civilfox.app/mock-test',
          publisher: { '@type': 'Organization', name: 'CivilFox', url: 'https://civilfox.app' },
        }}
      />
      <header className="cf-feature-nav">
        <Link to="/" className="cf-brand"><span>CivilFox</span></Link>
        <nav aria-label="Study tools">
          <Link to="/pyq-search">Search PYQs</Link>
          <Link to="/news">Current affairs</Link>
        </nav>
      </header>
      <main>
        <section className="cf-sec dark cf-feature-intro">
          <h1 className="cf-title">Free UPSC Prelims Daily Mock Test</h1>
          <p className="cf-lead">
            Build a consistent practice routine with a fresh Civil Services Prelims question
            paper each day. Download the question paper and a separate answer sheet to check
            your attempt.
          </p>
        </section>
        <DailyMockTest />
        <section className="cf-sec cream cf-feature-details">
          <h2 className="cf-title">How to use the daily practice paper</h2>
          <p className="cf-lead">
            Attempt the question paper under timed conditions before opening the answer sheet.
            Review your mistakes, then revise the related topics and past questions.
          </p>
          <p className="cf-feature-link">
            <Link to="/pyq-search">Search UPSC and other available exam PYQs →</Link>
          </p>
        </section>
      </main>
      <footer className="cf-foot">
        <Link to="/" className="cf-brand light"><span>CivilFox</span></Link>
        <div>
          <Link to="/pyq-search">PYQ search</Link>
          <Link to="/news">Current affairs</Link>
          <Link to="/about">About</Link>
        </div>
      </footer>
    </div>
  );
}
